/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/banner" endpoint
 */
import { isAppsAppGroupIdChartsBannerResult } from "@dashboardApi/apis/appsAppGroupIdChartsBanner/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsBanner } from "./constants";
import type { AppsAppGroupIdChartsBannerResult } from "./types";

export const getAppsAppGroupIdChartsBanner = reactQueryFetcherAdapter(
  appsAppGroupIdChartsBanner,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsBannerResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/banner`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  },
  isAppsAppGroupIdChartsBannerResult
);
